import { BugCheckOutlineIcon } from './BugCheckOutlineIcon';

/**
 * author: Michael Richins
 * id 1DF96664-B3AE-4028-BB22-C9DE9273A641
 * name bug-check-outline
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bug-check-outline.svg
 * tags
 * - Animal 
 */
export const BugTickOutlineIcon = BugCheckOutlineIcon;
export default BugTickOutlineIcon